import { render } from "./support-list-item.vue?vue&type=template&id=d0a1b208"
import script from "./support-list-item.vue?vue&type=script&lang=js"
export * from "./support-list-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__